import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export const fetchServerStatusService = () => letrusAPI('/api/v1/status/');
